import React from 'react';
import { Tooltip, Icon } from 'antd';
import cn from 'classnames';
import ApplicantIcons from '../../../../components/requestComponents/ApplicantIcons/ApplicantIcons';
import styles from './RequestsUserWrapper.module.scss';
import workerCellStyles from '../../../../components/WorkerCell/WorkerCell.module.scss';

const typesWorker = {
  applicant: {
    render: ({ request }) => (
      <>
        {request.contactType && request.clientName && (
          <ApplicantIcons contactType={request.contactType} />
        )}
        <span>{request.clientName || 'Не указано'}</span>
      </>
    ),
  },

  creator: {
    render: ({ request }) => (
      <>
        <Icon type="solution" />
        <div className={styles.contentWrap}>
          {request.createUser?.speciality && (
            <div className={workerCellStyles.speciality}>
              {request.createUser?.speciality}
            </div>
          )}
          <div>{request.createUser?.fullName || 'Не указано'}</div>
        </div>
      </>
    ),
  },
};

export const RequestsUserWrapper = ({
  title,
  withCursor,
  contentType,
  request,
  ...props
}) => {
  return (
    <Tooltip
      mouseEnterDelay={0.6}
      mouseLeaveDelay={0}
      title={title}
      placement="topLeft"
    >
      <div
        {...props}
        className={cn(styles.container, withCursor ? styles.activeCursor : '')}
      >
        {contentType && typesWorker[contentType].render({ request })}
      </div>
    </Tooltip>
  );
};
